export enum RelationalActionKinds {
  Calculate = 5,
  TextPaste = 6,
  ParentAlert = 7,
  ScriptLinkOutput = 8,
  ScriptLinkInput = 9,
  MksTemplateFormat = 11,
  ObjectLink = 12,
  DesignateDoctor = 13,
  Bookmark = 14,
  MksTemplateRegisteredId = 16,
  NumberingIdentifier = 17,
  UserDefineLinkValue = 18,
  UserDefineSearch = 19,
  DynamicTemplateFormat = 20,
  DynamicTemplateRegisteredId = 21,
  Alternative = 22,
}
